import { render, staticRenderFns } from "./IvyedLogo.vue?vue&type=template&id=102dc933&scoped=true&"
import script from "./IvyedLogo.vue?vue&type=script&lang=js&"
export * from "./IvyedLogo.vue?vue&type=script&lang=js&"
import style0 from "./IvyedLogo.vue?vue&type=style&index=0&id=102dc933&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102dc933",
  null
  
)

export default component.exports